import { call, put } from 'redux-saga/effects';
import { deleteChartOfAccountTemplate } from '../api';
import {
  deleteChartOfAccountsTemplateFailure,
  deleteChartOfAccountsTemplateSuccess,
  fetchChartOfAccountsTemplatesRequest,
} from '../actions';
import { DeleteChartOfAccountsTemplateRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundARY-TYPES */
export function* deleteChartOfAccountsTemplateSaga(
  action: DeleteChartOfAccountsTemplateRequestAction
) {
  try {
    let err: ApiError | null;
    const { templateId } = action.payload;

    const response = yield call(deleteChartOfAccountTemplate, templateId);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(deleteChartOfAccountsTemplateSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.template-deleted-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // Refresh templates list so UIs reflect deletion
    yield put(fetchChartOfAccountsTemplatesRequest());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(deleteChartOfAccountsTemplateFailure());
  }
}

